import { colors } from '@constants/colors';

import { IStyles } from './interfaces';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = (_props: IStyles) => {
  const { breakpoints } = useTheme();

  return {
    root: {
      width: '100%',
      height: 56,
      borderRadius: '500px',
      border: `1px solid ${colors.grey_10}`,

      [breakpoints.down(ScreenSizes.Tablet)]: {
        height: 48,
      },

      '&.MuiLinearProgress-root': {
        backgroundColor: colors.white,
      },
      '& .MuiLinearProgress-bar': {
        backgroundColor: colors.grey_10,
      },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 760px)
      //   and (max-device-width: 1180px)`]: {
      //   height: 40,
      // },
      // [`@media screen and (orientation:landscape)
      //   and (max-device-height: 570px)
      //   and (max-device-width: 900px)`]: {
      //   height: 30,
      // },
    },
  };
};
